enum SkapaDelayEnum {
	tight = '33ms',
	standard = '100ms',
	emphasised = '150ms'
}

export default SkapaDelayEnum;
